import RocketIcon from "@redotech/redo-icons/rocket-02.svg";
import { JSXElementConstructor, memo, MouseEvent } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";
import { RedoButton } from "../buttons/redo-button";
import {
  FeaturedIconColor,
  FeaturedIconType,
  RedoFeaturedIcon,
} from "../featured-icon/redo-featured-icon";
import * as redoEmptyStateCss from "./redo-empty-state.module.css";

export type EmptyStateButtonProps = {
  onClick: (event?: MouseEvent<HTMLButtonElement>) => void;
  text: string;
};

/**
 * Arbiter empty state https://www.figma.com/design/iZHj2I36zd9i8nRbWKw4ZK/%E2%9D%96-Arbiter?node-id=1547-269979&t=sTAJa3mMkpmOVvjw-0
 */
export const RedoEmptyState = memo(function RedoEmptyState({
  text,
  Icon,
  iconColor,
  iconType,
  subtext,
  primaryButtonProps,
  secondaryButtonProps,
}: {
  text: string;
  Icon?: JSXElementConstructor<any>;
  iconColor?: FeaturedIconColor | undefined;
  iconType?: FeaturedIconType | undefined;
  subtext: string;
  primaryButtonProps?: EmptyStateButtonProps;
  secondaryButtonProps?: EmptyStateButtonProps;
}) {
  return (
    <Flex
      align="center"
      dir="column"
      gap="xs"
      grow={1}
      justify="flex-start"
      px="4xl"
      py="8xl"
      style={{ width: "100%" }}
    >
      <RedoFeaturedIcon
        color={iconColor}
        Icon={Icon || RocketIcon}
        size="lg"
        type={iconType}
      />
      <Text fontSize="md" fontWeight="semibold" pt="md" textColor="primary">
        {text}
      </Text>
      <Text
        className={redoEmptyStateCss.subtext}
        fontSize="sm"
        textColor="tertiary"
      >
        {subtext}
      </Text>
      <Flex dir="row" gap="lg" pt="xl">
        {secondaryButtonProps && (
          <RedoButton
            centerItems={false}
            hierarchy="secondary"
            onClick={secondaryButtonProps.onClick}
            size="sm"
            text={secondaryButtonProps.text}
          />
        )}
        {primaryButtonProps && (
          <RedoButton
            centerItems={false}
            hierarchy="primary"
            onClick={primaryButtonProps.onClick}
            size="sm"
            text={primaryButtonProps.text}
          />
        )}
      </Flex>
    </Flex>
  );
});
